<re-pill [class]="class">{{ label }}</re-pill>
